module.exports = __webpack_public_path__ + "media/מגפיים.e879ac71.mp3";